import { compose, graphql } from 'react-apollo';
import { AllTasks } from '../../queries/AllTasks';
import { paginationVariables, withPagination } from '../../utils/pagination';
import mapConnection from '../../utils/connectionMapper';

export const initialFilters = {
  assigneeIds: [],
  claimStatuses: [],
  taskTypes: [],
  taskStatuses: [],
  taskPriorities: [],
  passengerFullNames: [],
  claimIds: [],
  passengerEmails: [],
};

const withAllTasksQuery = WrappedComponent =>
  compose(
    withPagination(initialFilters),
    graphql(AllTasks, {
      options: ({ filter, ...rest }) => ({
        variables: {
          filter,
          ...paginationVariables(rest),
        },
        notifyOnNetworkStatusChange: true,
      }),
      props: ({ data: { tasksConnection, variables, error, refetch, loading } }) => ({
        error,
        tasks: mapConnection(tasksConnection) || [],
        variables: variables || {},
        totalCount: tasksConnection ? tasksConnection.totalCount : 0,
        refetchTasks: refetch,
        loading,
        pageInfo: tasksConnection ? tasksConnection.pageInfo : {},
      }),
    })
  )(WrappedComponent);

export default withAllTasksQuery;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/withAllTasksQuery.js